import {
  withTranslation,
} from 'react-i18next';

import RegattaResultSequenceSectionView from './RegattaResultSequenceSectionView';

const TranslatedComponent = withTranslation()(RegattaResultSequenceSectionView);

const Component = TranslatedComponent;

export default Component;
